import { Box, Typography } from '@mui/material';
import InfoBox from 'components/info-box';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useCalibrationState } from '../../../context/calibration-context';

const SimpleCalibrationProgress: React.FC<{}> = () => {
  const PAGE_NAME_ID = 'bluViuNutrition.calibrations.editCalibration.calibrationInProgress';

  const {
    simpleCalibrationStatusQuery: { data: calibrationStatus },
  } = useCalibrationState();

  if (!calibrationStatus?.calibrationIsRunning) return;

  return (
    <InfoBox variant={'light'}>
      <Box display={'flex'} flexDirection={'column'} gap={1}>
        <Typography>
          <FormattedMessage id={`${PAGE_NAME_ID}.title`} />
        </Typography>
        <Typography>
          <FormattedMessage id={`${PAGE_NAME_ID}.text`} />
        </Typography>
      </Box>
    </InfoBox>
  );
};

export default React.memo(SimpleCalibrationProgress);
